__webpack_require__.S = {};
var initPromises = {};
var initTokens = {};
__webpack_require__.I = (name, initScope) => {
	if(!initScope) initScope = [];
	// handling circular init calls
	var initToken = initTokens[name];
	if(!initToken) initToken = initTokens[name] = {};
	if(initScope.indexOf(initToken) >= 0) return;
	initScope.push(initToken);
	// only runs once
	if(initPromises[name]) return initPromises[name];
	// creates a new share scope if needed
	if(!__webpack_require__.o(__webpack_require__.S, name)) __webpack_require__.S[name] = {};
	// runs all init snippets from all modules reachable
	var scope = __webpack_require__.S[name];
	var warn = (msg) => {
		if (typeof console !== "undefined" && console.warn) console.warn(msg);
	};
	var uniqueName = "portalHost";
	var register = (name, version, factory, eager) => {
		var versions = scope[name] = scope[name] || {};
		var activeVersion = versions[version];
		if(!activeVersion || (!activeVersion.loaded && (!eager != !activeVersion.eager ? eager : uniqueName > activeVersion.from))) versions[version] = { get: factory, from: uniqueName, eager: !!eager };
	};
	var initExternal = (id) => {
		var handleError = (err) => (warn("Initialization of sharing external failed: " + err));
		try {
			var module = __webpack_require__(id);
			if(!module) return;
			var initFn = (module) => (module && module.init && module.init(__webpack_require__.S[name], initScope))
			if(module.then) return promises.push(module.then(initFn, handleError));
			var initResult = initFn(module);
			if(initResult && initResult.then) return promises.push(initResult['catch'](handleError));
		} catch(err) { handleError(err); }
	}
	var promises = [];
	switch(name) {
		case "default": {
			register("@okta/okta-react", "6.11.0", () => (Promise.all([__webpack_require__.e(1186), __webpack_require__.e(5774), __webpack_require__.e(6437), __webpack_require__.e(8816)]).then(() => (() => (__webpack_require__(96437))))));
			register("@playgami/portal-logs", "1.5.0", () => (__webpack_require__.e(9657).then(() => (() => (__webpack_require__(89657))))));
			register("@playgami/ui/sonner", "0.114.4", () => (Promise.all([__webpack_require__.e(9424), __webpack_require__.e(6567), __webpack_require__.e(3662), __webpack_require__.e(2553), __webpack_require__.e(8316), __webpack_require__.e(5193), __webpack_require__.e(4017)]).then(() => (() => (__webpack_require__(34017))))));
			register("@playgami/ui/sonner", "0.114.4", () => (Promise.all([__webpack_require__.e(9424), __webpack_require__.e(6567), __webpack_require__.e(3662), __webpack_require__.e(2553), __webpack_require__.e(8316), __webpack_require__.e(5193), __webpack_require__.e(5925)]).then(() => (() => (__webpack_require__(25925))))));
			register("lodash", "4.18.1", () => (__webpack_require__.e(6537).then(() => (() => (__webpack_require__(86537))))));
			register("react-dom", "18.3.1", () => (() => (__webpack_require__(70316))), 1);
			register("react-redux", "9.2.0", () => (__webpack_require__.e(3828).then(() => (() => (__webpack_require__(3828))))));
			register("react-router-dom", "5.3.4", () => (Promise.all([__webpack_require__.e(7923), __webpack_require__.e(2975)]).then(() => (() => (__webpack_require__(47923))))));
			register("react", "18.3.1", () => (() => (__webpack_require__(22155))), 1);
			register("redux", "5.0.1", () => (() => (__webpack_require__(90805))), 1);
			initExternal(66473);
			initExternal(22887);
			initExternal(42895);
			initExternal(18691);
			initExternal(96308);
			initExternal(20498);
			initExternal(47567);
			initExternal(12651);
			initExternal(16970);
			initExternal(98257);
			initExternal(8250);
			initExternal(87927);
			initExternal(66493);
			initExternal(55731);
			initExternal(90153);
			initExternal(98104);
			initExternal(77184);
			initExternal(14060);
			initExternal(29087);
			initExternal(32436);
			initExternal(3072);
			initExternal(51274);
			initExternal(11211);
			initExternal(43997);
			initExternal(36173);
			initExternal(91109);
			initExternal(71974);
			initExternal(54779);
			initExternal(90656);
			initExternal(5020);
			initExternal(33043);
			initExternal(17977);
			initExternal(56661);
			initExternal(11910);
			initExternal(43215);
		}
		break;
	}
	if(!promises.length) return initPromises[name] = 1;
	return initPromises[name] = Promise.all(promises).then(() => (initPromises[name] = 1));
};